import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PolitiqueCookiesPage() {
  useDocumentTitle("Politique de cookies", "Politique de cookies ShinRai Consulting : types de cookies utilisés, finalités, durée, gestion du consentement.");
  return (
    <main className="pt-28 pb-24 bg-pearl min-h-screen" data-testid="cookies-page">
      <article className="max-w-3xl mx-auto px-6 sm:px-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-mute hover:text-ink transition mb-10">
          <ArrowLeft size={14} /> Retour à l'accueil
        </Link>

        <div className="font-mono-overline text-mute mb-3">Légal</div>
        <h1 className="font-serif text-5xl leading-tight mb-8">Politique de cookies</h1>
        <p className="text-mute mb-12">Cette politique décrit comment SHINRAI CONSULTING utilise les cookies et technologies similaires sur le site shinrai.fr.</p>

        <section className="space-y-12 text-mute leading-relaxed">
          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Qu'est-ce qu'un cookie ?</h2>
            <p>
              Un cookie est un petit fichier texte déposé sur ton terminal (ordinateur, tablette, smartphone) lors de la visite d'un site.
              Il permet au site de mémoriser des informations sur ta visite (préférences, statistiques, identifiants de session…) afin
              d'améliorer l'expérience utilisateur.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Cookies utilisés sur ce site</h2>

            <h3 className="font-serif text-lg text-ink mt-6 mb-2">Cookies strictement nécessaires</h3>
            <p>
              Ces cookies sont indispensables au fonctionnement du site (gestion de session, sécurité, panier). Ils ne nécessitent pas
              ton consentement préalable.
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 marker:text-gold">
              <li><code>session_id</code> — Maintien de session de navigation · durée : session</li>
              <li><code>shin-banner-closed</code> — Mémorisation de la fermeture de la bannière promotionnelle · durée : session</li>
              <li><code>shinrai-admin-password</code> — Authentification administrateur (espace privé uniquement) · durée : session</li>
            </ul>

            <h3 className="font-serif text-lg text-ink mt-6 mb-2">Cookies de mesure d'audience</h3>
            <p>
              Ces cookies nous aident à comprendre comment les visiteurs utilisent le site (pages visitées, durée, parcours). Ils nécessitent
              ton consentement.
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 marker:text-gold">
              <li><code>posthog</code> — Mesure d'audience anonymisée · durée : 13 mois maximum</li>
            </ul>

            <h3 className="font-serif text-lg text-ink mt-6 mb-2">Cookies tiers (services embarqués)</h3>
            <p>
              Le site embarque les services suivants, qui peuvent déposer leurs propres cookies :
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1 marker:text-gold">
              <li><strong>TidyCal</strong> — réservation de créneaux de diagnostic (iframe) — <a className="underline" href="https://tidycal.com/privacy-policy" target="_blank" rel="noopener noreferrer">politique</a></li>
              <li><strong>Stripe</strong> — paiements sécurisés — <a className="underline" href="https://stripe.com/fr/privacy" target="_blank" rel="noopener noreferrer">politique</a></li>
              <li><strong>Google Fonts</strong> — chargement des polices Cormorant Garamond et Manrope</li>
              <li><strong>Unsplash</strong> — images du site</li>
            </ul>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Durée de conservation</h2>
            <p>
              Les cookies déposés ne sont pas conservés au-delà d'une durée de <strong>13 mois</strong>. À l'expiration de ce délai, ton
              consentement te sera à nouveau demandé.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Gérer les cookies</h2>
            <p className="mb-3">
              Tu peux à tout moment retirer ton consentement ou paramétrer les cookies via les préférences de ton navigateur :
            </p>
            <ul className="list-disc pl-6 space-y-1 marker:text-gold">
              <li>Google Chrome : Paramètres → Confidentialité et sécurité → Cookies</li>
              <li>Firefox : Paramètres → Vie privée et sécurité</li>
              <li>Safari : Préférences → Confidentialité</li>
              <li>Edge : Paramètres → Cookies et autorisations de site</li>
            </ul>
            <p className="mt-4">
              Attention : la désactivation de certains cookies peut altérer le fonctionnement du site.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-ink mb-3">Contact</h2>
            <p>
              Pour toute question relative à l'utilisation des cookies sur ce site, contacte-nous à
              <a className="underline ml-1" href="mailto:info@shinrai.fr">info@shinrai.fr</a>.
            </p>
          </div>
        </section>

        <p className="text-xs text-mute mt-12">Politique mise à jour le 17/05/2026.</p>
      </article>
    </main>
  );
}
